import { create } from 'zustand';

const useAdminProfileStore = create((set) => ({
  profile: null,
  isLoading: false,
  error: null,
  
  setProfile: (profile) => set({
    profile,
    isLoading: false,
    error: null
  }),
  
  updateProfile: (updates) => set((state) => ({
    profile: { ...state.profile, ...updates },
    isLoading: false,
    error: null
  })),
  
  setError: (error) => set({
    error,
    isLoading: false
  }),
  
  setLoading: (isLoading) => set({ isLoading }),
  
  clearProfile: () => set({
    profile: null,
    isLoading: false,
    error: null
  }),
}));

export default useAdminProfileStore;